import * as React from "react";
const SvgAlignCenterLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 6a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h16a1 1 0 0 0 1-1m0 8a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h16a1 1 0 0 0 1-1m-4-5a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm1 9a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1", clipRule: "evenodd" }));
export default SvgAlignCenterLine;
